// @ts-strict-ignore
import { JsonObject, JsonProperty } from '@shared/convert/convert-core';

@JsonObject('ArticleAccessoryInfoVO')
export class ArticleAccessoryInfoVO {
  @JsonProperty('articleId', 'Number')
  public articleId: number = undefined;
  @JsonProperty('accessoryArticleIds', '[Number]')
  public accessoryArticleIds: number[] = undefined;
  /**
   * Further rotation which might be applied additionally to already determined rotation by e.g. UVN.
   * This array is in lock-step with accessoryArticleIds and thus provides indvidual delta for each accessory article.
   */
  @JsonProperty('accessoryRotationDeltas', '[Number]')
  public accessoryRotationDeltas: number[] = undefined;
}

@JsonObject('ArticleAccessoryEntryVO')
export class ArticleAccessoryEntryVO {
  @JsonProperty('accessoryArticleId', 'Number')
  public accessoryArticleId: number = undefined;

  @JsonProperty('accessoryArticleNumber', 'String')
  public accessoryArticleNumber: string = undefined;

  @JsonProperty('rotationDelta', 'Number')
  public rotationDelta: number = undefined;
}
